import { createReducer } from '@reduxjs/toolkit';
import { getAllNationalitiesAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllNationalitiesAction, (state, action) => {
    state.list = action.payload;
  })
);
